import { gql } from '@apollo/client';

/**
 * Runs the crawl inline — budget ~2s per active source. Callers must raise the
 * request timeout (see `KB_SYNC_TIMEOUT_MS`) or a succeeding sync gets aborted.
 */
export const SYNC_KB_WEBSITE_URLS = gql`
  mutation SyncKbWebsiteUrls {
    syncKbWebsiteUrls {
      statusCode
      message
      results {
        url
        status
        chars
        message
      }
    }
  }
`;
